/* eslint-disable react-hooks/rules-of-hooks */
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {View, TextInput, Dimensions, Platform} from 'react-native';

import {
  Description,

  Container,
  ModalContent,
  Header,
  CloseButton,
  CloseButtonText,
  LottieContainer,
  Title,
  Content,
  ModalFooter,
  ButtonContainer,
  ButtonBackText,
  ButtonBack,
  ButtonConfirm,
  ButtonConfirmText,
  CellText,
  CellContainer,
  CloseButtonIcon,
  CodeContainer,
  ErrorText,
  Divider,
  LinkButtonContainer,
} from './styles';

import LottieView from 'lottie-react-native';
import {api} from '../../../services/api';
import {WebCodeField} from './WebCodeField';

let CodeField: any;
let Cursor: any;
let useBlurOnFulfill: any;
let useClearByFocusCell: any;

if (Platform.OS !== 'web') {
  const lib = require('react-native-confirmation-code-field');
  CodeField = lib.CodeField;
  Cursor = lib.Cursor;
  useBlurOnFulfill = lib.useBlurOnFulfill;
  useClearByFocusCell = lib.useClearByFocusCell;
} else {
  CodeField = WebCodeField;
  Cursor = View;
  useBlurOnFulfill = () => ({current: null});
  useClearByFocusCell = () => [{}, () => () => {}];
}


import {ButtonTimer} from '../../Interface/Forms/Buttons/ButtonTimer';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import {useAuth} from '../../../context/auth';
import {OverlayModal} from '../OverlayModal';

import { LinkButton } from '../../Interface/Forms/Buttons/LinkButton';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  dismissable?: boolean;
}

const COUNTDOWN_INITIAL_TIME_IN_SECONDS = 2 * 60; // 2 MINUTOS

export function OTPModal({isOpen, onClose, dismissable = true}: Props) {
  const [step, setStep] = useState<'INITIAL' | 'SMS' | 'SUCCESS'>('INITIAL');

  const canDismiss = dismissable || step === 'SUCCESS';

  const otpSecurityAnimation = require('../../../assets/images/json/otp-security.json');
  const smsValidationAnimation = require('../../../assets/images/json/sms-validation.json');
  const successAnimation = require('../../../assets/images/json/success.json');

  const {markPhoneAsVerified} = useAuth();

  const [resendButtonIsEnabled, setResendButtonIsEnabled] = useState(false);

  const [secondsAmount, setSecondsAmount] = useState(
    COUNTDOWN_INITIAL_TIME_IN_SECONDS,
  );

  const [value, setValue] = useState('');
  const [codeError, setCodeError] = useState('');
  const [isVerifyingCode, setIsVerifyingCode] = useState(false);

  const attemptedCodeRef = useRef('');
  const useBlurOnFulfillSafe =
    typeof useBlurOnFulfill === 'function'
      ? useBlurOnFulfill
      : () => useRef(null);
  const useClearByFocusCellSafe =
    typeof useClearByFocusCell === 'function'
      ? useClearByFocusCell
      : () => [{}, () => () => {}];

  const ref = useBlurOnFulfillSafe({value, cellCount: 6});
  const [props, getCellOnLayoutHandler] = useClearByFocusCellSafe({
    value,
    setValue,
  });

  const sendSMSVerificationCode = useCallback(async () => {
    try {
      setCodeError('');
      await api.post('/phone_verifications');
    } catch (error) {
      setCodeError('Não conseguimos enviar o SMS. Tente reenviar em instantes.');
    }
  }, []);

  const verifySMSCode = useCallback(
    async (code: string) => {
      try {
        setIsVerifyingCode(true);
        setCodeError('');
        const response = await api.post('/phone_verifications/verify', {code});

        if (response?.status === 200 && response?.data?.ok) {
          await markPhoneAsVerified();
          setStep('SUCCESS');
          return;
        }

        setCodeError('Código inválido. Confira e tente novamente.');
      } catch (error: any) {
        setCodeError(
          error?.response
            ? 'Código inválido. Confira e tente novamente.'
            : 'Sem conexão. Tente novamente.',
        );
      } finally {
        setIsVerifyingCode(false);
      }
    },
    [markPhoneAsVerified],
  );

  function handleResendCode() {
    setResendButtonIsEnabled(false);
    setSecondsAmount(COUNTDOWN_INITIAL_TIME_IN_SECONDS);
    setValue('');
    attemptedCodeRef.current = '';
    sendSMSVerificationCode();
  }

  useEffect(() => {
    if (step !== 'SMS') {
      return;
    }

    setValue('');
    setCodeError('');
    attemptedCodeRef.current = '';
    setSecondsAmount(COUNTDOWN_INITIAL_TIME_IN_SECONDS);
    setResendButtonIsEnabled(false);
    sendSMSVerificationCode();
  }, [step]);

  useEffect(() => {
    if (step !== 'SMS') {
      return;
    }

    if (value.length < 6) {
      if (attemptedCodeRef.current) {
        setCodeError('');
      }
      attemptedCodeRef.current = '';
      return;
    }

    if (isVerifyingCode || attemptedCodeRef.current === value) {
      return;
    }

    attemptedCodeRef.current = value;
    verifySMSCode(value);
  }, [step, value, verifySMSCode, isVerifyingCode]);

  useEffect(() => {
    if (!isOpen || step !== 'SMS') {
      return;
    }

    if (secondsAmount === 0) {
      setResendButtonIsEnabled(true);
      return;
    }

    const timer = setTimeout(() => setSecondsAmount(state => state - 1), 1000);
    return () => clearTimeout(timer);
  }, [isOpen, secondsAmount, step]);

  const renderOTPInitialScreen = () => (
    <>
      <Container>
        <LottieContainer>
          {otpSecurityAnimation && (
            <LottieView
              source={otpSecurityAnimation}
              autoPlay
              loop
              style={{
                width: '70%',
                height: '95%',
              }}
              resizeMode="cover"
            />
          )}
        </LottieContainer>
        <Content>
          <Title>
            Confirme seu número para aproveitar benefícios exclusivos
          </Title>
          <Description>
            Valide seu número de celular via SMS para receber nossas MELHORES ofertas, promoções e vantagens exclusivas direto no aplicativo.
          </Description>
        </Content>
      </Container>

      <ModalFooter>
        <ButtonContainer>
          {canDismiss && (
            <ButtonBack onPress={() => onClose()} activeOpacity={0.7}>
              <ButtonBackText>Agora não</ButtonBackText>
            </ButtonBack>
          )}
          <ButtonConfirm onPress={() => setStep('SMS')} activeOpacity={0.7}>
            <ButtonConfirmText>Continuar</ButtonConfirmText>
          </ButtonConfirm>
        </ButtonContainer>
      </ModalFooter>
    </>
  );

  const renderSMS = () => (
    <>
      <Container>
        <LottieContainer style={{height: RFPercentage(18)}}>
          {smsValidationAnimation && (
            <LottieView
              source={smsValidationAnimation}
              autoPlay
              style={{
                width: '60%',
                height: '90%',
              }}
              loop={false}
              resizeMode="cover"
            />
          )}
        </LottieContainer>
        <Content>
          <Title>Verifique seus SMS</Title>
          <Description>
            Enviamos um código de 6 dígitos para o número cadastrado. Digite-o
            abaixo para confirmar seu número:
          </Description>

          <CodeContainer>
            <CodeField
              InputComponent={TextInput}
              ref={ref as any}
              {...props}
              value={value}
              onChangeText={setValue}
              autoFocus
              autoComplete="sms-otp"
              importantForAutofill="yes"
              inputMode="numeric"
              autoCorrect={false}
              autoCapitalize="none"
              textInputStyle={{
                borderRadius: RFValue(12),
              }}
              cellCount={6}
              keyboardType="number-pad"
              textContentType="oneTimeCode"
              renderCell={({index, symbol, isFocused}: any) => (
                <CellContainer key={index} isFocused={isFocused}>
                  <CellText
                    onLayout={(e: any) => getCellOnLayoutHandler(index)(e)}>
                    {symbol || (isFocused ? <Cursor /> : null)}
                  </CellText>
                </CellContainer>
              )}
            />
          </CodeContainer>

          {!!codeError && <ErrorText>{codeError}</ErrorText>}

          <ButtonTimer
            timer={secondsAmount}
            onPress={() => handleResendCode()}
            disabled={!resendButtonIsEnabled}
            style={{
              opacity: resendButtonIsEnabled ? 1 : 0.4,
              marginBottom: RFValue(10),
            }}
          />

          <Divider />

          {canDismiss && (
            <LinkButtonContainer>
              <LinkButton action={() => onClose()} enabled text="Validar depois" />
            </LinkButtonContainer>
          )}
        </Content>

      </Container>
    </>
  );

  const renderSuccessScreen = () => (
    <>
      <Container>
        <LottieContainer style={{height: RFPercentage(18)}}>
          {successAnimation && (
            <LottieView
              source={successAnimation}
              autoPlay
              style={{
                width: '50%',
                height: '90%',
              }}
              loop={false}
              resizeMode="cover"
            />
          )}
        </LottieContainer>
        <Content>
          <Title>Telefone validado com sucesso!</Title>
          <Description>
            Seu número está confirmado e você passa a receber promoções
            especiais e ofertas exclusivas. Fique atento às notificações para
            aproveitar ao máximo os benefícios.
          </Description>
        </Content>
      </Container>

      <ModalFooter>
        <ButtonContainer>
          <ButtonConfirm onPress={onClose} activeOpacity={0.7}>
            <ButtonConfirmText>Obrigado!</ButtonConfirmText>
          </ButtonConfirm>
        </ButtonContainer>
      </ModalFooter>
    </>
  );

  const {height} = Dimensions.get('window');
  const modalMaxHeight =
    step === 'SMS'
      ? height * 0.75
      : step === 'SUCCESS'
      ? height * 0.55
      : height * 0.7;

  return (
    <OverlayModal
      isVisible={isOpen}
      onBackdropPress={canDismiss ? onClose : undefined}
      onBackButtonPress={canDismiss ? onClose : undefined}
      onModalHide={() => setStep('INITIAL')}
      animationIn="fadeIn"
      animationOut="fadeOut"
      backdropOpacity={0.5}
      style={{margin: 0, alignItems: 'center', justifyContent: 'center'}}>
      <ModalContent style={{maxHeight: modalMaxHeight}}>
        <Header>
          {step === 'INITIAL' && canDismiss && (
            <CloseButton onPress={onClose}>
              <CloseButtonText>✕</CloseButtonText>
            </CloseButton>
          )}

          {step === 'SMS' && (
            <CloseButton onPress={() => setStep('INITIAL')}>
              <CloseButtonIcon name="chevron-left" />
            </CloseButton>
          )}

          {step === 'SUCCESS' && (
            <CloseButton onPress={onClose}>
              <CloseButtonText>✕</CloseButtonText>
            </CloseButton>
          )}
        </Header>

        {step === 'INITIAL' && renderOTPInitialScreen()}
        {step === 'SMS' && renderSMS()}
        {step === 'SUCCESS' && renderSuccessScreen()}
      </ModalContent>
    </OverlayModal>
  );
}
